/**
 * Valida CPF ou CNPJ
 * @param {string} documento - CPF ou CNPJ a ser validado (com ou sem máscara)
 * @returns {boolean} - Retorna true se for válido
 */
export function validarCPFCNPJ(cpfCnpj) {
    // Remove caracteres não numéricos
    var numero = cpfCnpj.replace(/\D/g, "");
    // Verifica se é CPF (11 dígitos)
    if (numero.length === 11) {
        return validarCPF(numero);
    }
    // Verifica se é CNPJ (14 dígitos)
    if (numero.length === 14) {
        return validarCNPJ(numero);
    }
    // Se não for nem CPF nem CNPJ
    return false;
}
/**
 * Valida CPF
 * @param {string} cpf - CPF a ser validado (apenas números)
 * @returns {boolean} - Retorna true se for válido
 */
function validarCPF(cpf) {
    // Verifica se tem 11 dígitos e não é uma sequência repetida
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
        return false;
    }
    // Calcula o primeiro dígito verificador
    var soma = 0;
    for (var i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
    }
    var resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11)
        resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) {
        return false;
    }
    // Calcula o segundo dígito verificador
    soma = 0;
    for (var i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11)
        resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) {
        return false;
    }
    return true;
}
/**
 * Valida CNPJ
 * @param {string} cnpj - CNPJ a ser validado (apenas números)
 * @returns {boolean} - Retorna true se for válido
 */
function validarCNPJ(cnpj) {
    // Verifica se tem 14 dígitos e não é uma sequência repetida
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) {
        return false;
    }
    // Valida primeiro dígito verificador
    var pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    var soma = 0;
    for (var i = 0; i < 12; i++) {
        soma += parseInt(cnpj.charAt(i)) * pesos1[i];
    }
    var resto = soma % 11;
    var dv1 = resto < 2 ? 0 : 11 - resto;
    if (dv1 !== parseInt(cnpj.charAt(12))) {
        return false;
    }
    // Valida segundo dígito verificador
    var pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    soma = 0;
    for (var i = 0; i < 13; i++) {
        soma += parseInt(cnpj.charAt(i)) * pesos2[i];
    }
    resto = soma % 11;
    var dv2 = resto < 2 ? 0 : 11 - resto;
    if (dv2 !== parseInt(cnpj.charAt(13))) {
        return false;
    }
    return true;
}
